import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function getRedirectUrl(props) {
  if (props.outside && (!props.user.permissions || !props.user.permissions.createDashboards)) {
    return '/no-create-dashboard-permissions';
  }

  if (!props.user.permissions || !props.user.permissions.createDashboards) {
    return '/no-dashboards';
  }
}

export default function(ComposedComponent) {
  class RequireCreateDashboards extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const redirectUrl = getRedirectUrl(this.props);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      outside: state.app.outside,
      user: state.auth.user
    };
  }

  return connect(mapStateToProps)(RequireCreateDashboards);
}
